import dayjs from 'dayjs';

export default {
  // 返回月份中的第一天是星期几
  firstDayOfMonth(date: any) {
    const d = date.constructor === Date ? date : this.cloneDate(date, 'dd', 1);
    return d.getDay();
  },
  // 获取当月天数
  getDaysInMonth(year: any, month: any) {
    return new Date(year, month, 0).getDate();
  },
  // 获取当月天数
  getDaysByDate(date: any) {
    const tmp = this.parseDate(date);
    return new Date(tmp.getFullYear(), tmp.getMonth() + 1, 0).getDate();
  },
  // 获取当月信息
  getCurrMonthInfo(year: any, month: any) {
    return {
      dayCount: new Date(year, month, 0).getDate(), // 总天数
      firstDay: new Date(year, month, 1).getDay(), // 第一天是周几
    };
  },
  // 判断闰年还是平年
  isLeapYear(year: any) {
    if (!+year) {
      throw new Error('年份格式不正确');
    }
    if (+year < 1790) {
      throw new Error('年份不能低于1790');
    }
    return (+year % 4 === 0 && +year % 100 !== 0) || +year % 400 === 0;
  },
  // 获取时间差的月份数
  getMonthCount(date1: any, date2: any) {
    const tmp1 = this.parseDate(date1);
    const tmp2 = this.parseDate(date2);
    const dur =
      (tmp2.getFullYear() - tmp1.getFullYear()) * 12 +
      (tmp2.getMonth() - tmp1.getMonth());
    return Math.abs(dur) + 1;
  },
  // 是否是今天(只判断年月日)
  isToday(date: any) {
    return this.isOneDay(date, new Date());
  },
  // 两个日期是否同一天
  isOneDay(date1: any, date2: any) {
    if (!date1 || !date2) { return false; }
    const tmp1 = this.parseDate(date1);
    const tmp2 = this.parseDate(date2);
    return tmp1.toDateString() === tmp2.toDateString();
  },
  // 两个日期是否同一个月
  isOneMonth(date1: any, date2: any) {
    if (!date1 || !date2) { return false; }
    const tmp1 = this.parseDate(date1);
    const tmp2 = this.parseDate(date2);
    return tmp1.getFullYear() === tmp2.getFullYear() && tmp1.getMonth() === tmp2.getMonth();
  },
  // 周几
  getDay(date: any, opt: any) {
    const realDate = this.cloneDate(date);
    let array = ['周日', '周一', '周二', '周三', '周四', '周五', '周六'];
    if (opt && opt instanceof Array) {
      array = opt;
    }
    return array[realDate.getDay()];
  },
  // 标准化日期, 时间均为00:00:00
  parseDay(date: any) {
    const tmp = this.parseDate(date);
    return new Date(tmp.getFullYear(), tmp.getMonth(), tmp.getDate());
  },
  // 标准化时间
  parseDate(date: any) {
    if (date.constructor === Date) { return date; }
    // ↓ 错误，ios 格式 2022-09才为正常 2022/09会返回NaN
    // if (date.constructor === String) {
    //   date = +date ? +date : date.replace(/-/gi, '/');
    // }
    return new Date(date);
  },
  // 克隆日期
  cloneDate(date: any, type?: any, during?: any) {
    const tmp = new Date(this.parseDate(date));
    if (!type || !during) { return tmp; }
    switch (type) {
      case 'y':
        tmp.setFullYear(tmp.getFullYear() + during);
        break;
      case 'yyyy':
        tmp.setFullYear(during);
        break;
      case 'm':
        tmp.setMonth(tmp.getMonth() + during);
        break;
      case 'mm':
        tmp.setMonth(during);
        break;
      case 'd':
        tmp.setDate(tmp.getDate() + during);
        break;
      case 'dd':
        tmp.setDate(during);
        break;
      default: break;
    }
    return tmp;
  },
  // 格式化为"x年x月x日"
  formatChineseDate(date: any, type?: string) {
    const year = dayjs(date).format('YYYY');
    const month = dayjs(date).format('MM');
    const day = dayjs(date).format('DD');

    if (type === 'month') {
      return `${year}年${month}月`;
    }
    return `${year}年${month}月${day}日`;
  },
  /**
   * @param date
   * @return 格式为'YYYY-MM'的次月
   */
  getNextYearAndMonth(date = new Date()) {
    const nowMonth = Number(dayjs(date).format('M'));
    const nextMonth = nowMonth === 12 ? 1 : nowMonth + 1;
    let year = new Date(date).getFullYear();
    if (nowMonth === 12) {
      year += 1;
    }
    const nextYearAndMonth = dayjs(`${year}-${nextMonth}`).format('YYYY-MM');
    return nextYearAndMonth;
  },

  /**
   * 按分钟步长得到整分时间
   * @param date 
   * @param step 
   */
  moveTime(date: any, step: any) {
    const now = dayjs(date).second(0).millisecond(0);
    const minute = now.minute();
    if (minute % step > 0) {
      return now.minute(Math.ceil(minute / step) * step).toDate()
    }
    return now.toDate();
  },

  /**
   * 月份转换
   * @param str 
   * @return  1=>一  12=>十二
   */
  monthConversion(str: any) {
    if (str == '1') {
      str = '一'
    } else if (str == '2') {
      str = '二'
    } else if (str == '3') {
      str = '三'
    } else if (str == '4') {
      str = '四'
    } else if (str == '5') {
      str = '五'
    } else if (str == '6') {
      str = '六'
    } else if (str == '7') {
      str = '七'
    } else if (str == '8') {
      str = '八'
    } else if (str == '9') {
      str = '九'
    } else if (str == '10') {
      str = '十'
    } else if (str == '11') {
      str = '十一'
    } else if (str == '12') {
      str = '十二'
    }
    return str;
  },

  /**
 * 获取当前日期前几个月的日期
 * @param month 
 * @return  
 */
  getBeforeDate(month: any) {
    // 当前日期
    let now = new Date();
    // 获取当前日期的前三个月的月份
    let pastMonth = now.getMonth() - month;
    // 修改月份，如果前三个月对应没有该日期，则向后延顺
    now.setMonth(pastMonth);
    return now;

  },
  /**
 * [dateAddDays 从某个日期增加或者减少n天后的日期]
 * @param  {[string]} dateStr  [日期字符串]
 * @param  {[int]} dayCount [增加的天数]
 * @param  {[string]} type add增加  reduce减少
 * @return {[string]}[增加n天后的日期字符串]
 */
  getNewDateFormDays(dateStr: any, dayCount: any, type: any = 'add'): string {
    let tempDate: any = new Date(dateStr.replace(/-/g, "/"));//把日期字符串转换成日期格式
    let resultDate: any = ''
    if (type == 'add') {
      resultDate = new Date((tempDate / 1000 + (86400 * dayCount)) * 1000);//增加n天后的日期
    } else {
      resultDate = new Date((tempDate / 1000 - (86400 * dayCount)) * 1000);//增加n天后的日期
    }
    let resultDateStr = resultDate.getFullYear() + "/" + (resultDate.getMonth() + 1) + "/" + (resultDate.getDate());//将日期转化为字符串格式
    return resultDateStr;
  }
};
